module.exports = require('./dist/InfiniteScroll')



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-infinite-scroller/index.js
 ** module id = 1382
 ** module chunks = 0
 **/